export const hasMediaAccess = () => !!navigator.mediaDevices;
export const canQueryPermissions = () => !!navigator.permissions?.query;
export const getUserMedia = (...args) =>
  navigator.mediaDevices?.getUserMedia(...args);
